module.exports = __webpack_public_path__ + "static/media/ps-no_activity.ad64fb89.png";